<div *ngIf="!isLoading" class="favorites-container">
  <ng-container *ngIf="purchasedStreams?.length">
    <h3 class="favorites-subheader" data-testid="purchased-streams-title">Purchased</h3>
    <div class="cards-list cards-list--upcoming">
      <app-stream-schedule-card
        data-testid="purchased-streams"
        class="card"
        *ngFor="let stream of purchasedStreams"
        [stream]="stream"
        [isVisibleIndicator]="true"
      >
      </app-stream-schedule-card>
    </div>
  </ng-container>

  <div *ngIf="purchasedStreams?.length && favoritesStreams?.length" class="separator"></div>

  <ng-container *ngIf="favoritesStreams?.length">
    <h3 class="favorites-subheader" data-testid="favorite-streams-title">Favorites</h3>
    <div class="cards-list cards-list--upcoming">
      <app-stream-schedule-card
        data-testid="favorite-streams"
        class="card"
        *ngFor="let stream of favoritesStreams"
        [stream]="stream"
      >
      </app-stream-schedule-card>
    </div>
  </ng-container>

  <ng-container *ngIf="!purchasedStreams?.length && !favoritesStreams?.length">
    <div class="empty">
      <img
        src="assets/ui/images/svg/empty-favorites.svg"
        width="130"
        height="130"
        alt="empty-favorites"
      />
      <div class="empty__text">Time to stock up!</div>
      <a class="empty__button" [routerLink]="'/scheduled-streams'">see what’s coming up</a>
    </div>
  </ng-container>
</div>
